import React from "react";
import Rainbow from "../hoc/Rainbow";

const About = () => {
  return (
    <div className="container">
      <h4 className="center">About</h4>
      <p>
        Welcome to KC Tech Jobs. A job board which shows you available techical
        jobs in the Kansas City area.
      </p>
    </div>
  );
};

export default Rainbow(About);
